export default String.raw`
function ready(callback){
	if(document.readyState != 'loading'){
		callback();
	} else {
		document.addEventListener("DOMContentLoaded", callback);
	}
}

ready(() => {
	js.events();
});

window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};

const js = {
	post: async (params = '', url = location.href) => {
		params.__csrf =  __CSRF;
		const res = await fetch(url, {
            method: 'POST',
            cache: 'no-cache',
            headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            referrerPolicy: 'strict-origin-when-cross-origin',
            body: Object.keys(params).map(key => key + '=' + params[key]).join('&')
		});
		return res.json();
	},
	get: async (paramName, paramValue, url = location.pathname) => {
		if(url.includes('?')){
			var sign = '&__';
		} else {
			var sign = '?__';
		}
		let res = await fetch(url+sign+paramName+'='+paramValue, {headers:{'X-Requested-With': 'XMLHttpRequest'}});
		let data = await res.json();
		return data[paramName];
	},
	delegate: (el, evt, sel, handler) => {
		if(sel.includes(',')){
			var selArr = sel.split(',');
			for(let i=0; i < selArr.length; i++){
				if(selArr[i].charAt(0) == ' '){
					selArr[i] = selArr[i].replace(' ','');
				}
			}
		} else {
			var selArr = [sel];
		}
		el.addEventListener(evt, function(event) {
			for(let j=0; j < selArr.length; j++){
				var t = event.target;
				if(selArr[j].includes(' ')){
					let selArrElementsArr = selArr[j].split(' ').reverse();
					let trigger = '';
					while (t && t !== this && (!t.matches('.stop-propagation-js') || (t.matches('.stop-propagation-js') && trigger != '')) && selArrElementsArr.length > 0) {
						if (t.matches(selArrElementsArr[0])) {
							if (trigger == '') {
								trigger = t;
							}
							selArrElementsArr.shift();
						}
						t = t.parentNode;
					}
					if (trigger != '' && selArrElementsArr.length == 0) {
						handler.call(trigger, event);
					}
				} else {
					while (t && t !== this && !t.matches('.stop-propagation-js')) {
						if (t.matches(selArr[j])) {
							handler.call(t, event);
						}
						t = t.parentNode;
					}
				}
			}
		});
	},
	parents: (el, parentSelector) => {
		let p = el.parentNode;
		while (p != document && !p.classList.contains(parentSelector)) {
			p = p.parentNode;
		}
		if(p == document){
			p = null;
		}
		return p;
	},
	getFormInputs: (form) => {
		const inputs = form.querySelectorAll('input:not([disabled]), select:not([disabled]), textarea:not([disabled])');
		let params = {};
		Array.from(inputs).forEach(function(el) { 
			if (params[el.name] !== undefined) {
				if (!Array.isArray(params[el.name])) {
					params[el.name] = [params[el.name]];
				}
				params[el.name].push(el.value);
			} else {
				params[el.name] = el.value;
			}
		});
		return params;
	},
	checkDeligooAvailability: async (el, e) => {
		if(app.validationBeforePost(e) != 'error'){
			const form = js.parents(el, 'form-js');
			let params = js.getFormInputs(form);
			if(document.querySelectorAll('[name="productType"]').length > 0){
				let products = [];
				if(document.querySelectorAll('[name="supplyId"]').length > 0){
					if(document.querySelector('[name="productType"]').value == 'clip'){
						products = [{ProductId: Number(document.querySelector('[name="supplyId"]').value)}];
					} else {
						products = [{ProductId: Number(document.querySelector('[data-product-id]').dataset.productId), SupplyId: Number(document.querySelector('[name="supplyId"]').value)}];
					}
				} else {
					products = [{ProductId: Number(document.querySelector('[data-product-id]').dataset.productId)}];
				}
				params.products = JSON.stringify(products);
			}
			const res = await js.post(params);
			if(res.action.Result){
				document.getElementsByClassName('deligoo-success-js')[0].classList.remove('hidden-js');
				document.getElementsByClassName('deligoo-success-icon-js')[0].classList.remove('hidden-js');
				document.getElementsByClassName('deligoo-error-js')[0].classList.add('hidden-js');
				document.getElementsByClassName('deligoo-error-icon-js')[0].classList.add('hidden-js');
				if(document.getElementsByClassName('deligoo-on-cart-js').length > 0){
					document.getElementsByClassName('close-deligoo-popup-js')[0].classList.remove('deligoo-fail-js');
				}
			} else {
				document.getElementsByClassName('deligoo-success-js')[0].classList.add('hidden-js');
				document.getElementsByClassName('deligoo-success-icon-js')[0].classList.add('hidden-js');
				document.getElementsByClassName('deligoo-error-js')[0].classList.remove('hidden-js');
				if(document.getElementsByClassName('deligoo-on-cart-js').length > 0){
					document.getElementsByClassName('check-deligoo-availability-popup-js')[0].classList.remove('hidden-js');
					document.getElementsByClassName('close-deligoo-popup-js')[0].classList.add('deligoo-fail-js');
				}
			}
		}
	},
    produceOffer: async function() {
		const trigger = this;
		const id = trigger.dataset.id;
		const data = {
			__action: 'Inquiry/CartMerge',
			inquiryId: id,
			__collection: 'customer.Cart.Id'
		}
		const result = await js.post(data);
		if (result.action.Result) {
			const cartId = result.collection;
			window.app.setCookie('lastCartId', cartId);
			const message = trigger.dataset.message;
            app.temporaryPopupMessage(undefined, message, result.action.Type);
			setTimeout(() => {
				const url = trigger.dataset.redirectUrl;
				app.replace(url);
			}, 4000)
		} else {
			const title = trigger.dataset.title;
			const info = trigger.dataset.info;
			const goToCart = trigger.dataset.goToCart;
			const changeCart = trigger.dataset.changeCart;
			const url = trigger.dataset.redirectUrl;
			document.body.innerHTML += '<div class="message-popup-background offer-exists-in-cart-popup-js container-to-delete-js">'+
											'<div class="popup-container">'+
												'<div class="data-form__header">'+
													'<span>'+title+'</span>'+
                                                    '<button class="close-button cancel-js" aria-label="'+__translations.Close+'">'+
                                                        '<i><svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg></i> '+
                                                    '</button>'+
												'</div>'+
												'<div class="info">'+
													'<div>'+info+'</div>'+
                                                    '<div class="buttons-container">'+
                                                        '<button class="pure-button open-carts-list-popup-js">'+changeCart+'</button>'+
                                                        '<button class="primary-action-button replace-url-js" data-url="'+url+'">'+
                                                            '<span>'+goToCart+'</span>'+
                                                        '</button>'+
                                                    '</div>'+
												'</div>'+
											'</div>'+
										'</div>'
            const popupMessage = $('.errors-js');
			const closeFunction = () => {
				popupMessage.find('.cancel-js').click();
			}
			app.setLockFocus(popupMessage, () => closeFunction(), $(document.activeElement));
		}
	},
    setInnerHTML: (elm, html) => {
        elm.innerHTML = html;
        Array.from(elm.querySelectorAll("script")).forEach( oldScript => {
          const newScript = document.createElement("script");
          Array.from(oldScript.attributes)
            .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
    },
    rivetsPropertyCheck: (bindedObj, property) => {
        if(bindedObj[property] != '' && bindedObj[property] != null){
            const newProperty = property  + 'Exists';
            bindedObj[newProperty] = true;
        }
    },
    showMoreManufacturers: () => {
        const hiddenManufacturers = document.querySelectorAll('.manufacturer-js.hidden-js');
        
        hiddenManufacturers.forEach((manufacturer, index) => {
            if (index < 12) {
                manufacturer.classList.remove('hidden-js');
            }
        });
    
        if (document.querySelectorAll('.manufacturer-js.hidden-js').length === 0) {
            document.querySelector('.show-more-manufacturers-js').classList.add('hidden-js');
            document.querySelector('.show-less-manufacturers-js').classList.remove('hidden-js');
        }
    },
    showLessManufacturers: () => {
        const manufacturers = document.querySelectorAll('.manufacturer-js');
    
        manufacturers.forEach((manufacturer, index) => {
            if (index >= 12) {
                manufacturer.classList.add('hidden-js');
            }
        });
    
        document.querySelector('.show-less-manufacturers-js').classList.add('hidden-js');
        document.querySelector('.show-more-manufacturers-js').classList.remove('hidden-js');
    },    
    toggleEmployee: (e) => {
        if(app.validationBeforePost(e) != 'error'){
            var form = $(e.currentTarget).parents('.form-js');
            var data = form.find('input:not([disabled])').serializeArray();
            data.push({name: "__csrf", value: __CSRF});
            $.post('', data, function(result) {
                app.serverMessage(result, form, e);
                if (result.action.Result) {
                    $('.employees-list-view-js').html(result.template);
                }
            });
        }
    },
    
    updateTotalPriceOnShoppingList: () => {
        const products = document.getElementsByClassName('product-item-js')
        for(let product of products){
            const input = product.querySelector('[name=quantity]');
            if(input != null){
                const quantity = Number(input.value.replace(',','.'));
                if( quantity >= 2 ){
                    const price = input.dataset.priceNumber;
                    const totalPrice = Number(price.replace(',','.')) * quantity;
                    product.getElementsByClassName('total-price-on-list-view-js')[0].textContent = totalPrice.toPrice();
                }
            }
        }
    },

    updateDepositPriceOnShoppingList: () => {
        const products = document.getElementsByClassName('product-item-js')
        for(let product of products){
            const input = product.querySelector('[name=quantity]');
            if(input != null){
                const quantity = Number(input.value.replace(',','.'));
                if( quantity >= 2 ){
                    const deposit = input.dataset.deposit;
                    const depositPrice = Number(deposit.replace(',','.')) * quantity;
                    product.getElementsByClassName('total-deposit-on-list-view-js')[0].textContent = depositPrice.toPrice();
                }
            }
        }
    },
    setTotalPriceOnProductsList: function() {
        const trigger = this;
        setTimeout(() => {
            if(trigger.classList.contains('change-quantity-js')){
                var input = trigger.parentElement.querySelector('[name=quantity]');
            } else {
                var input = trigger;
            }
            const quantity = input.value;
            const price = input.dataset.priceNumber;
            const totalPrice = Number(price.replace(',','.')) * Number(quantity.replace(',','.'));
            const product = js.parents(trigger, 'product-item-js');
            product.getElementsByClassName('total-price-on-list-view-js')[0].textContent = totalPrice.toPrice();
        },100);
    },
    setDepositPriceOnProductsList: function() {
        const trigger = this;
        setTimeout(() => {
            if(trigger.classList.contains('change-quantity-js')){
                var input = trigger.parentElement.querySelector('[name=quantity]');
            } else {
                var input = trigger;
            }
            const quantity = input.value;
            const deposit = input.dataset.deposit;
            const depositPrice = Number(deposit.replace(',','.')) * Number(quantity.replace(',','.'));
            const product = js.parents(trigger, 'product-item-js');
            product.getElementsByClassName('total-deposit-on-list-view-js')[0].textContent = depositPrice.toPrice();
        },100);
    },
    showSuggestedPrice: () => {
        const list = document.getElementsByClassName('suggested-price-product-list')[0];
        if(list){
            const quick = js.parents(list, 'quick-shopping-view-js');
            if(list && quick) { 
                if(window.innerWidth < 1280 && window.innerWidth > 700) {
                    list.style.top = '25%';
                    list.style.right = '0';  
                } else if (window.innerWidth < 700) {
                    list.style.top = '35%';
                    list.style.right = '0';  
                } else {
                    list.style.top = '-5%';
                    list.style.right = '-20%';
                }
            } else if(list) {
                list.style.top = '25%';
                list.style.right = '20px';
            }
        }
    },

    refreshStars: () => {
        const rating = $('[name=rating]').val();
        const stars = $('.choose-rating-js');

        stars.each(function (index) {
            const reversedIndex = 5 - index;

            if (rating >= reversedIndex) {
                $(this).addClass('reviewed')
            } else {
                $(this).removeClass('reviewed');
            }
        });
    }, 
    chooseRating: function(e) {
        const rating = e.currentTarget.dataset.rating;
        document.querySelector('[name=rating]').value = rating;
        js.refreshStars();
    },
    addReview: (e) => {
        if(app.validationBeforePost(e) != 'error'){
            var form = $(e.currentTarget).parents('.form-js');
            var data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            data.push({name: "__csrf", value: __CSRF});
            data.push({name: "__template", value: 'partials/product/product-presentation-data.html'});
            if(location.hash.includes('hash')){
                var hash = location.hash.split('=')[1];
                data.push({name: "orderHash", value: hash});
            }
            $.post('', data, function(result) {
                if (result.action.Result) {
                    $('.product-presentation-js').html(result.template);
                    var description = result.action.Description;
                    const elements = document.getElementsByClassName('review-content-js');
                    for(let element of elements){
                        if (element.offsetHeight == element.scrollHeight) {
                            const buttons = element.parentNode.getElementsByClassName('toggle-more-review-js');
                            for(let button of buttons){
                                button.classList.add('hidden-js');
                            }
                        }
                    }
                } else {
                    if(result.action.Description){  
                        var description = result.action.Description;
                    } else {
                        var description = result.action.Validation[0].Error;
                    }
                }
                app.temporaryPopupMessage(undefined, description, result.action.Type);
    
                if (result.action.Code == 0 && $('.reportContent-js').index() >= 0) {
                    setTimeout(function() {
                        window.location.reload();
                    }, 3000);
                } else if (result.action.Code == 0) {
                    $('.adding-review-form-js .close-js').trigger('click');
                    js.resetReviewForm();
                } else if (result.action.Code == 4001) {
                    js.resetReviewForm();
                }
                if ($('.product-presentation-js').length > 0) {
                    app.getProperBackground();
                    productDetails.init();
                    if ($('.sets-container').length > 0) {
                        if (typeof window.initSetSlider === 'function') {
                            window.initSetSlider();
                        }
                    }
                
                    if ($('.related-container').length > 0) {
                        if (typeof window.initRelatedSlider === 'function') {
                            window.initRelatedSlider();
                        }
                    }
                }
            });
        }
    },
    resetReviewForm: () => {
        $('input[name="author"], textarea[name="comment"]').val('');

        const stars = document.querySelectorAll('.choose-rating-js');
        stars.forEach(star => {
           star.classList.remove('reviewed');
        });
    
        const ratingInput = document.querySelector('input[name="rating"][type="hidden"]');
        if (ratingInput) {
            ratingInput.value = 0;
        }
    
        const formElements = document.querySelectorAll('input:not([type="hidden"]), textarea');
        formElements.forEach(element => {
            const parent = element.parentNode;
            
            parent.querySelectorAll('.validation-required-js').forEach(item => item.classList.add('hidden-js'));
            parent.querySelectorAll('.form__input-info').forEach(item => item.classList.remove('validation-error'));
            parent.querySelectorAll('.validation-error-js').forEach(item => item.classList.remove('validation-error-js'));
    
            const label = parent.querySelector('label');
            if (label) {
                label.classList.remove('validation-error-js');
            }
        });
    
        app.formLabelAnimationOnLoadPage();
    },
    
    
    sendReviewReport: (e) => {
        e.preventDefault();
        e.stopPropagation();

        if(app.validationBeforePost(e) != 'error'){
            let form = $(e.currentTarget).parents('.form-js');
            let data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            let isChecked = [false, false, false];
            let indexesToRemove = [-1, -1, -1];

            for (const d of data) {
                if (d.name == 'RelatedToEUDirectiveOffense') {
                    if (d.value == 'true' || d.value == true) {
                        isChecked[0] = true;
                    }
                    indexesToRemove[0] = (data.indexOf(d));
                }
                    
                if (d.name == 'informationAccuracyConfirmation') {
                    if (d.value == 'true' || d.value == true) {
                        isChecked[1] = true;
                    }
                    indexesToRemove[1] = (data.indexOf(d));
                }
                    
                if (d.name == 'trustedNotifierEntityAgreement') {
                    if (d.value == 'true' || d.value == true) {
                        isChecked[2] = true;
                    }
                    indexesToRemove[2] = (data.indexOf(d));
                }
            }

            indexesToRemove[2] != -1 ? data.splice(indexesToRemove[2], 1) : null;
            indexesToRemove[1] != -1 ? data.splice(indexesToRemove[1], 1) : null;
            indexesToRemove[0] != -1 ? data.splice(indexesToRemove[0], 1) : null;

            let consents1 = {
                Type: 1,
                Content: $('input[name="RelatedToEUDirectiveOffenseContent"]').val(),
                IsChecked: isChecked[0]
            };

            let consents2 = {
                Type: 2,
                Content: $('input[name="informationAccuracyConfirmationContent"]').val(),
                IsChecked: isChecked[1]
            }

            let consents3 = {
                Type: 3,
                Content: $('input[name="trustedNotifierEntityAgreementContent"]').val(),
                IsChecked: isChecked[2]
            }

            let consents = [consents1, consents2, consents3];
            data.push({name: 'consents', value: JSON.stringify(consents)});

            if ($('#selectDSA').index() >= 0 && !($('#selectDSA').val())) {  
               var popup = '<div class="message-popup-background errors-js cancel-js container-to-delete-js">'+
                            '<div class="popup-container message-popup-on-background-js">'+
                                '<div class="data-form__header">'+
                                    '<span>'+__translations.Com_FormErrors+'</span>'+
                                    '<button class="close-button cancel-js" aria-label="{{ translation.Close }}">'+
                                        '<i><svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg></i> '+
                                    '</button>'+
                                '</div>'+
                                '<div class="info">'+
                                    '<div>'+__translations.ReportContentType+': '+__translations.Com_FieldIsMandatory+'</div>'+
                                '</div>'+
                            '</div>';
                $('body').append(popup);
                const popupMessage = $('.errors-js');
                const closeFunction = () => {
                    popupMessage.find('.cancel-js').click();
                }
                app.setLockFocus(popupMessage, () => closeFunction(), $(document.activeElement));
                return;
            } else {
                data.push({name: "__csrf", value: __CSRF});
                data.push({name: "__template", value: 'partials/product/product-presentation-data.html'});
    
                $.post('', data, function(result) {
                    if(result.action.Description){
                        var description = result.action.Description;
                    } else if (result.action.Validation && result.action.Validation[0].Error) {
                        var description = result.action.Validation[0].Error;
                    } else {
                        var description = '';
                    }
    
                    if (result.action.Result) {
                        $('.product-presentation-js').html(result.template);
                        const elements = document.getElementsByClassName('review-content-js');
                        for(let element of elements){
                            if (element.offsetHeight == element.scrollHeight) {
                                const buttons = element.parentNode.getElementsByClassName('toggle-more-review-js');
                                for(let button of buttons){
                                    button.classList.add('hidden-js');
                                }
                            }
                        }
                    }
    
                    let msg = result.action.Message != null ? result.action.Message: '';
                    app.temporaryPopupMessage(undefined, msg, result.action.Type);

                    if (result.action.Code == 0 && $('.reportContent-js').index() >= 0) {
                        setTimeout(function() {
                            window.location.reload();
                        }, 3000);
                    }
                    app.getProperBackground();

                    if ($('.product-presentation-js').length > 0) {
                        productDetails.init();
                    }

                    if ($('.sets-container').length > 0) {
                        if (typeof window.initSetSlider === 'function') {
                            window.initSetSlider();
                        }
                    }
                
                    if ($('.related-container').length > 0) {
                        if (typeof window.initRelatedSlider === 'function') {
                            window.initRelatedSlider();
                        }
                    }
                });
            }
        }
    },
    openAddReviewForm: () => {
        const addingReviewForm = document.querySelector('.adding-review-form-js');
        if (addingReviewForm) {
            addingReviewForm.classList.remove('hidden-js');
        }
        app.formLabelAnimationOnLoadPage();
    },    
    toggleMoreReview: () => {
        const elements = document.getElementsByClassName('review-content-js');
        for(let element of elements){
            element.classList.toggle('more-review');
        }
    },
    downloadMoreReviews: async (e) => {
        const showButton = e.target;
        const url = showButton.dataset.url;
        const template = await js.get('template', 'partials/product/reviews-list.html', url);
        showButton.parentNode.remove();
        document.getElementsByClassName('reviews-list-js')[0].innerHTML += template;
        const elements = document.getElementsByClassName('review-content-js');
        for(let element of elements){
            if (element.offsetHeight == element.scrollHeight) {
                const buttons = element.parentNode.getElementsByClassName('toggle-more-review-js');
                for(let button of buttons){
                    button.classList.add('hidden-js');
                }
            }
        }
    },
    pagerEvents: type => {
        if (type == "order") {
            var button = ".order-button-js:not([disabled])";
            var input = ".order-input-js";
            window.pagerEventsInitializedOrder = true;
        } else if (type == "invoice") {
            var button = ".invoice-button-js:not([disabled])";
            var input = ".invoice-input-js";
            window.pagerEventsInitializedInvoice = true;
        } else if (type == "sor") {
            var button = ".sor-button-js:not([disabled])";
            var input = ".sor-input-js";
            window.pagerEventsInitializedSOR = true;
        } else if (type == "wm") {
            var button = ".wm-button-js:not([disabled])";
            var input = ".wm-input-js";
            window.pagerEventsInitializedWM = true;
        }
        $("body").on("click", button, function(e) {
            document.querySelector(".erp-data-container-js").style.display = "none";
            if ($(e.currentTarget).hasClass("prev-js")) {
                window.erpPageNo = window.erpPageNo - 1;
                app.replaceTemplate(e, undefined, js.loadErpDetails, type);
            } else if ($(e.currentTarget).hasClass("next-js")) {
                window.erpPageNo = window.erpPageNo + 1;
                app.replaceTemplate(e, undefined, js.loadErpDetails, type);
            }
        });
        $("body").on("keydown", input, function(e) {
            var input = $(e.currentTarget);
            var max = Number($(".page-count-js").text());
            if (e.keyCode == 13) {
                var inputVal = Number(input.val());
                if (inputVal != window.erpPageNo && inputVal >= 1 && inputVal <= max) {
                    window.erpPageNo = inputVal;
                    app.replaceTemplate(e, undefined, js.loadErpDetails, type);
                } else if (inputVal < 1) {
                    window.erpPageNo = 1;
                    app.replaceTemplate(e, undefined, js.loadErpDetails, type);
                } else if (inputVal > max) {
                    window.erpPageNo = max;
                    app.replaceTemplate(e, undefined, js.loadErpDetails, type);
                }
            }
        });
        $("body").on("change", input, function(e) {
            var input = $(e.currentTarget);
            var max = Number($(".page-count-js").text());
            var inputVal = Number(input.val());
            if (inputVal != window.erpPageNo && inputVal >= 1 && inputVal <= max) {
                window.erpPageNo = inputVal;
                app.replaceTemplate(e, undefined, js.loadErpDetails, type);
            } else if (inputVal < 1) {
                window.erpPageNo = 1;
                app.replaceTemplate(e, undefined, js.loadErpDetails, type);
            } else if (inputVal > max) {
                window.erpPageNo = max;
                app.replaceTemplate(e, undefined, js.loadErpDetails, type);
            }
        });
    },
    loadErpDetails: async detailsType => {
        if (detailsType == "order") {
            var commandHeader = "CDN.eShop_GetOrderDetailsHeader";
            var command = "CDN.eShop_GetOrderDetails";
            var commandAttr = "CDN.eShop_GetOrderElementsAttributes";
            var id = window.erpOrderId
        } else if (detailsType == "invoice") {
            var commandHeader = "CDN.eShop_GetInvoiceDetailsHeader";
            var command = "CDN.eShop_GetInvoiceDetails";
            var commandAttr = "CDN.eShop_GetInvoiceElementsAttributes";
            var id = window.erpInvoiceId
        } else if (detailsType == "sor") {
            var commandHeader = "CDN.eShop_GetSORDetailsHeader";
            var command = "CDN.eShop_GetSORDetails";
            var commandAttr = "CDN.eShop_GetSORElementsAttributes";
            var id = window.erpSORId
        } else {
            var commandHeader = "CDN.eShop_GetWMDetailsHeader";
            var command = "CDN.eShop_GetWMDetails";
            var commandAttr = "CDN.eShop_GetWMElementsAttributes";
            var id = window.erpWMId
        }
        const headerData = {
            __action: "sync/exec",
            worker: "erpData",
            message: JSON.stringify({
                command: commandHeader,
                parameters: {
                    Id: id,
                    LanguageId: __lngId
                }
            })
        };
        const headerDataResult = await js.post(headerData);
        let header = headerDataResult.action.Object[0][0];
        const headerAttributes = headerDataResult.action.Object[1];
        const headerAttrQuantity = headerAttributes.length;
        const relatedDocuments = headerDataResult.action.Object[2];
        if (relatedDocuments) {
            var relatedDocQuantity = relatedDocuments.length;
        }
        let attrToShow = 0;
        let container = document.getElementsByClassName("header-attributes-js")[0];
        if (headerAttrQuantity > 0) {
            for (let i = 0; i < headerAttrQuantity; i++) {
                if (headerAttributes[i].Value != "") {
                    if (attrToShow % 3 == 0) {
                        container.innerHTML += '<div class="order-details__row details-info-row-js"></div>';
                    }
                    let rows = container.getElementsByClassName("details-info-row-js");
                    let lastRow = rows[rows.length - 1];
                    if (headerAttributes[i].Type == 7) {
                        lastRow.innerHTML += '<div class="order-details-item">' + '<label>' + headerAttributes[i].Name + "</label>" + '<span><a href="' + headerAttributes[i].Value + '">' + headerAttributes[i].Value + "</a></span>" + "</div>";
                    } else {
                        lastRow.innerHTML += '<div class="order-details-item">' + '<label>' + headerAttributes[i].Name + "</label>" + '<span>' + headerAttributes[i].Value + "</span>" + "</div>";
                    }
                    attrToShow++;
                }
            }
            if (attrToShow > 0) {
                header.AttributesExist = true;
            }
        }
        if (relatedDocQuantity && relatedDocQuantity > 0) {
            const documentsContainer = document.getElementsByClassName("related-documents-js")[0];
            documentsContainer.innerHTML = "";
            const relatedERP = document.querySelector(".related-erp.hidden-js");

            if (relatedERP) {
                relatedERP.classList.remove("hidden-js");
            }

            for (let i = 0; i < relatedDocQuantity; i++) {
                let documentDate = new Date(relatedDocuments[i].Date);
                if (navigator.language == "pl" || navigator.language == "pol") {
                    const year = documentDate.getFullYear();
                    let month = documentDate.getMonth() + 1;
                    if (month < 10) {
                        month = "0" + month;
                    }
                    let day = documentDate.getDate();
                    if (day < 10) {
                        day = "0" + day;
                    }
                    documentDate = year + "-" + month + "-" + day;
                } else {
                    documentDate = documentDate.toLocaleDateString();
                }
                let url = document.getElementsByClassName("related-documents-js")[0].dataset.urlOrigin;
                let template = "partials/customer-profile/";
                let className = "load-erp-";
                const type = relatedDocuments[i].DocumentType;
                if (type == 0) {
                    url += "invoice-erp=true";
                    template += "invoices/invoice-details.html";
                    className += "invoice-details-js";
                } else if (type == 1) {
                    url += "sor-erp=true";
                    template += "sor/sor-details.html";
                    className += "sor-details-js";
                } else if (type == 2) {
                    url += "order-erp=true";
                    template += "orders/order-details.html";
                    className += "order-details-js";
                } else if (type == 3) {
                    url = document.getElementsByClassName("related-documents-js")[0].dataset.urlEshopOrders + relatedDocuments[i].Id + "&deeper-lvl&tab=order-details";
                    template += "orders/order-details.html";
                    className = "load-deeper-lvl-js open-order-details-js";
                }
                if (type == 0 && document.getElementsByClassName("related-documents-js")[0].classList.contains("invoicesAvailable-js") || type == 1 && document.getElementsByClassName("related-documents-js")[0].classList.contains("SORAvailable-js") || type == 2 && document.getElementsByClassName("related-documents-js")[0].classList.contains("erpOrdersAvailable-js") || type == 3) {
                    header.DocumentsExist = true;
                    documentsContainer.innerHTML += '<tr class="row">' + '<td tabindex="0" class="id pure-button parent-container-reload-js ' + className + '" ' + 'data-url="' + url + '" data-template="' + template + '" data-id="' + relatedDocuments[i].Id + '">' + relatedDocuments[i].DocumentNumber + "</td>" + '<td>' + documentDate + "</td>" + '<td>' + relatedDocuments[i].SubtotalValue.toPrice() + "</td>" + '<td>' + relatedDocuments[i].TotalValue.toPrice() + "</td>" + '<td>' + relatedDocuments[i].Currency + "</td>" + "</tr>";
                }
            }
        } else {
            $('.related-erp').addClass("hidden-js");
        }
        js.rivetsPropertyCheck(header, "DeliveryMethod");
        js.rivetsPropertyCheck(header, "Street");
        js.rivetsPropertyCheck(header, "InvoiceStreet");
        js.rivetsPropertyCheck(header, "UnitNo");
        js.rivetsPropertyCheck(header, "InvoiceUnitNo");
        js.rivetsPropertyCheck(header, "Email");
        if (detailsType == "order") {
            if (header.Status == -1) {
                header.Canceled = true;
            } else if (header.Status == 2 || header.Status == 3 || header.Status == 4) {
                header.Executed = true;
            }
            if (header.PaymentStatus == 0) {
                header.PaymentNotPaid = true;
            } else if (header.PaymentStatus == 1) {
                header.PaymentPaid = true;
            } else if (header.PaymentStatus == 2) {
                header.PaymentPaidPartially = true;
            }
            if (header.DeliveryStatus == 0) {
                header.DeliveryStatus0 = true;
            } else if (header.DeliveryStatus == 1) {
                header.DeliveryStatus1 = true;
            } else if (header.DeliveryStatus == 2) {
                header.DeliveryStatus2 = true;
            } else if (header.DeliveryStatus == 3) {
                header.DeliveryStatus3 = true;
            } else if (header.DeliveryStatus == 4) {
                header.DeliveryStatus4 = true;
            }
            if (header.DeliveryStatus == 0 || header.DeliveryStatus == 1 || header.DeliveryStatus == 2 || header.DeliveryStatus == 3 || header.DeliveryStatus == 4 || header.PaymentStatus == 0 || header.PaymentStatus == 1 || header.PaymentStatus == 2) {
                header.StatusExists = true;
            }
            if (header.DeliveryStatus == 0 || header.DeliveryStatus == 1 || header.DeliveryStatus == 2 || header.DeliveryStatus == 3 || header.DeliveryStatus == 4) {
                header.DeliveryStatusExists = true;
            }
            if (header.PaymentStatus == 0 || header.PaymentStatus == 1 || header.PaymentStatus == 2) {
                header.PaymentStatusExists = true;
            }
            if (header.DeliveryStatusExists && header.PaymentStatusExists) {
                header.DeliveryAndPaymentStatusExists = true;
            }
            js.rivetsPropertyCheck(header, "ImplementationDate");
            var erpNumber = header.ERPOrderNumber;
        } else if (detailsType == "invoice") {
            if (header.TotalValue >= 0) {
                header.Pay = true;
            } else {
                header.Return = true;
            }
            if (header.DaysAfterDueDate > 0 && (header.ToPay > 0 || header.ToReturn > 0)) {
                header.DaysAfterExists = true;
            }
            if (header.ToPay > 0) {
                header.ToPayExists = true;
                header.Paid = header.TotalValue - header.ToPay;
            }
            if (header.ToReturn > 0) {
                header.ToReturnExists = true;
                header.Returned = Math.abs(header.TotalValue) - header.ToReturn;
            }
            if (header.HasInvoicePDF == 1) {
                header.InvoicePDFExists = true;
            }
            var erpNumber = header.ERPInvoiceNumber;
        } else if (detailsType == "sor") {
            var erpNumber = header.ERPSORNumber;
        } else if (detailsType == "wm") {
            var erpNumber = header.ERPWMNumber;
        }
        document.getElementsByClassName("erp-number-js")[0].textContent = erpNumber;
        rivets.bind(document.getElementsByClassName("info-container-js")[0], header);
        document.getElementsByClassName("erp-number-js")[0].classList.remove("hidden-js");
        const elementsData = {
            __action: "sync/exec",
            worker: "erpData",
            message: JSON.stringify({
                command: command,
                parameters: {
                    Id: id,
                    PageNo: window.erpPageNo,
                    LanguageId: __lngId
                }
            })
        };
        const elementsDataResult = await js.post(elementsData);
        let elements = elementsDataResult.action.Object[0];
        const elementsQuantity = elements.Result.length;
        elements.ElementsQuantity = elementsQuantity;
        for (let i = 0; i < elementsQuantity; i++) {
            if (elements.Result[i].Description || elements.Result[i].HasDetails == 1) {
                elements.Result[i].DescriptionOrAttributesExists = true;
            }
            if (elements.Result[i].Description) {
                elements.Result[i].DescriptionExists = true;
            }
            if (elements.Result[i].Price > 0) {
                elements.Result[i].PriceExists = true;
            }
            if (elements.Result[i].Discount > 0) {
                elements.Result[i].DiscountExists = true;
                elements.AnyDiscountExists = true;
            }
            if (elements.Result[i].DocumentType = 1) {
                elements.Result[i].NettoPrices = true
            } else if (elements.Result[i].DocumentType = 2) {
                elements.Result[i].BruttoPrices = true;
            }
            if (elements.Result[i].HasDetails == 1) {
                elements.Result[i].AttributesExist = true;
                var anyElementHasDetails = true;
            }
        }
        if (elements.PageCount > 1) {
            elements.FewPages = true;
        }
        if (window.erpPageNo != undefined) {
            let next = document.querySelector(".pager-js .next-js");
            let prev = document.querySelector(".pager-js .prev-js");
            if (next) {
                if (window.erpPageNo == elements.PageCount) {
                    next.setAttribute("disabled", true);
                } else {
                    next.removeAttribute("disabled");
                }
            }
            if (prev) {
                if (window.erpPageNo == 1) {
                    prev.setAttribute("disabled", true);
                } else {
                    prev.removeAttribute("disabled");
                }
            }            
        }
        if (detailsType == "order") {
            var productsList = document.getElementsByClassName("order-products-list-js")[0];
        } else if (detailsType == "invoice") {
            var productsList = document.getElementsByClassName("invoice-products-list-js")[0];
        } else if (detailsType == "sor") {
            var productsList = document.getElementsByClassName("sor-products-list-js")[0];
        } else {
            var productsList = document.getElementsByClassName("wm-products-list-js")[0];
        }
        rivets.bind(productsList, elements);
        if (document.querySelector(".pager-js input")) {
            document.querySelector(".pager-js input").value = window.erpPageNo;
        }

        for (let i = 0; i < elementsQuantity; i++) {
            if (elements.Result[i].DescriptionExists) {
                const idContainers = document.getElementsByClassName("product-id-js");
                for (let idContainer of idContainers) {
                    if (idContainer.textContent == elements.Result[i].DocumentElementId) {
                        var ul = idContainer.nextElementSibling;
                    }
                }
                let description = elements.Result[i].Description.slice(0, -1);
                let descriptionElements = description.split(";");
                for (let j = 0; j < descriptionElements.length; j++) {
                    ul.innerHTML += "<li>" + descriptionElements[j] + "</li>";
                }
            }
        }
        if (anyElementHasDetails) {
            const attributesData = {
                __action: "sync/exec",
                worker: "erpData",
                message: JSON.stringify({
                    command: commandAttr,
                    parameters: {
                        Id: id,
                        LanguageId: __lngId
                    }
                })
            };
            const attributesDataResult = await js.post(attributesData);
            const attributes = attributesDataResult.action.Object[0];
            const attrQuantity = attributes.length;
            if (attrQuantity > 0) {
                for (let i = 0; i < attrQuantity; i++) {
                    let ul = document.querySelector('.product-id-js:contains("' + attributes[i].DocumentElementId + '")').nextSibling;
                    if (attributes[i].Type == 7) {
                        ul.innerHTML += "<li>" + attributes[i].Name + ': <a href="' + attributes[i].Value + '">' + attributes[i].Value + "</a></li>";
                    } else {
                        ul.innerHTML += "<li>" + attributes[i].Name + ": " + attributes[i].Value + "</li>";
                    }
                }
            }
        }
        document.querySelector(".erp-data-container-js + .loader-js").style.display = "none";
        document.getElementsByClassName("erp-data-container-js")[0].style.display = "block";
    },
    addManyProductsToCart: (obj, e) => {
        const clonedEvent = {...e};
        $.post('', { __action: 'Cart/Add', __csrf: __CSRF, __parameters: obj.parameters, __template: 'partials/common/header/client-area.html', __collection: 'customer.Cart.Id' }).then(function (res) {
            var products = res.action.Products;
            if(products.length > 0){
                var productsForDataLayer = [];
                var productsForGA4DataLayer = [];
                var productsForFBPixel = [];
                var productsForTTPixel = [];
                var productsForSCPixel = [];
                var totalValue = 0;
                var basicUnitTotalValue = 0;
                for(var i=0; i<products.length; i++){
                    var productDL = { id: products[i].Id.toString(), name: products[i].NameNoHtml, price: products[i].BasicUnitTotalPrice, quantity: products[i].BasicUnitQuantity };
                    var productGA4DL = { item_id: products[i].Id.toString(), item_name: products[i].NameNoHtml, price: products[i].TotalPrice, quantity: products[i].Quantity };
                    var productFBP = { id: products[i].Id.toString(), content_name: products[i].NameNoHtml, value: products[i].BasicUnitTotalPrice, quantity: products[i].BasicUnitQuantity };
                    var productTTP = { content_id: products[i].Id.toString(), content_name: products[i].NameNoHtml, price: products[i].BasicUnitTotalPrice, quantity: products[i].BasicUnitQuantity };
                    totalValue = totalValue + (products[i].TotalPrice * products[i].Quantity);
                    basicUnitTotalValue = basicUnitTotalValue + (products[i].BasicUnitTotalPrice * products[i].BasicUnitQuantity);
                    productsForDataLayer.push(productDL);
                    productsForGA4DataLayer.push(productGA4DL);
                    productsForFBPixel.push(productFBP);
                    productsForTTPixel.push(productTTP);
                    productsForSCPixel.push(products[i].Id.toString());
                }
                var dataLayerProds = {
                    "products": productsForDataLayer
                };
                window.dataLayer.push({
                    "event": "addToCart",
                    "ecommerce": {
                        "currencyCode": __currCode,
                        "add": dataLayerProds
                    }
                });
                if(typeof gtag != 'undefined'){
                    gtag("event", "add_to_cart", {
                        currency: __currCode,
                        value: totalValue,
                        items: productsForGA4DataLayer
                    });
                }
                if(typeof _edrone !== 'undefined') {
                    _edrone.action_type = 'add_to_cart';
                    _edrone.init();
                }
                if(typeof fbq !== 'undefined') {
                    fbq('track', 'AddToCart',
                        {
                            value: basicUnitTotalValue,
                            currency: __currCode,
                            content_type: 'product',
                            contents: productsForFBPixel
                        }
                    );
                }
                if(typeof ttq !== 'undefined') {
                    ttq.track('AddToCart',
                        {
                            value: basicUnitTotalValue,
                            currency: __currCode,
                            content_type: 'product',
                            contents: productsForTTPixel
                        }
                    );
                }
                if(typeof snaptr !== 'undefined') {
                    snaptr('track', 'ADD_CART',
                        {
                            price: basicUnitTotalValue,
                            currency: __currCode,
                            items_ids: productsForSCPixel,
                            number_items: i,
                            client_dedup_id: 'ADD_CART_' + new Date().getTime()
                        }
                    );
                }
            }
            var minQuantityTestPassed = app.serialAddingToCartMinQuantityCheck(res);
            if (!minQuantityTestPassed) {
                const isInquiry = e.currentTarget.classList.contains('add-to-inquiry-js');
                
                if (!isInquiry) {
                    const inputs = document.querySelector('.add-to-cart-js[data-include]').querySelectorAll('[name="quantity"][type="text"]');
                    const allUnits = document.querySelector('.add-to-cart-js[data-include]').querySelectorAll('.memory-js[data-index]');
                    const addToCartButton =  document.querySelector('.add-many-products-js');
                    
                    app.MMQVal(inputs, allUnits, addToCartButton);
                }
            }
            if (!res.action.Result) {
                if(minQuantityTestPassed){
                    app.serverMessage(res, obj.form, clonedEvent);
                    $('.client-area-js').html(res.template);
                } else {
                    window.changeParent();
                }
            } else {
                if(!$(clonedEvent.currentTarget).hasClass('add-to-inquiry-js') && (window.app.getCookie('lastCartId') == undefined || window.app.getCookie('lastCartId') == -1 || window.app.getCookie('lastCartId') == '')){
                    var cartId = res.collection;
                    window.app.setCookie('lastCartId', cartId);
                }
        
                if (obj.loadParent) {
                    var urls = $('[data-url]');
                    urls.each(function () {
                        var url = $(this).attr('data-url');
                        var newUrl = url.replace('keys=', '');
                        $(this).attr('data-url', newUrl);
                    });
                }
                window.changeParent();
    
                if(minQuantityTestPassed){
                    var message = res.action.Message;
                    if($(obj.e.currentTarget).hasClass('add-to-inquiry-js')) {
                        window.dispatchEvent(new CustomEvent('inquiry:added', {
                            detail: {
                                event: obj.e,
                                template: undefined,
                                products: products
                            }
                        }));
                    } else {
                        // to remove category popup after adding it to cart
                        const parent = js.parents(clonedEvent.target, 'container-to-remove-js');
                        if(parent){
                            parent.remove();
                        }
                        window.dispatchEvent(new CustomEvent('cart:added', {
                            detail: {
                                event: obj.e,
                                template: undefined,
                                products: products
                            }
                        }));
                    }
                }
       
                $('.client-area-js').html(res.template);
                window.changeHeaderCart();
            }
        });
    },
    addManyProducts: (e) => {
        var products = window.childs;
        var parameters = null;
        var form = $(e.currentTarget).parents('.form-js');
        if($(e.currentTarget).data('id') != undefined){
            var productId = $(e.currentTarget).data('id');
        } else {
            var productId = $('[data-product-id]').data('product-id');
        }

        var validationError = false;
        let sourceFromLink = false;
        let tmpSource = null;
    
        if($('.attr-poly-table-js').index() != -1){
            var max = $('[name=quantity]').data('max');
            var quantity = 0;
        }

        if ($('.product-presentation-js').index() >= 0) {
            const urlParameters = new URLSearchParams(window.location.search);
            const AIProductRecommendation = urlParameters.get('ai-recommendation');
            const AICartRecommendation = urlParameters.get('ai-cart-recommendation');
            
            if (AICartRecommendation) {
                sourceFromLink = true;
                tmpSource = 2;
            } else if (AIProductRecommendation){
                sourceFromLink = true;
                tmpSource = 1;
            }
        }

        let source = form.find('#sourceToAdd-js').val();
        if (!source && sourceFromLink) {
            $('#sourceToAdd-js').val(tmpSource);
            source = tmpSource;
        }
    
        var first = true;
        for(var i=0; i<products.length; i++){
            if(products[i].askForPriceChild == false && products[i].quantity > 0){
                if(products[i].buyAll){
                    var loadParent = true;
                }
                var supplyId = products[i].supply;
                var parameter = { productId: productId, quantity: products[i].quantity, unitId: products[i].unit, supplyId: supplyId,  ...(source ? { source: source.toString() } : {}), };
                if(products[i].attributesEditable != undefined && products[i].attributesEditable.length > 0){
                    for(var j=0; j<products[i].attributesEditable.length; j++){
                        if(products[i].attributesEditable[j] == '' || products[i].attributesEditable[j].replace(/\s/g, '').length == 0){
                            validationError = true;
                            app.temporaryPopupMessage(undefined, __translations.fillRequiredAttributes, 'err');
                            break;
                        }
                    }
                    parameter.attributeEditable = products[i].attributesEditable;
                }
                if(products[i].attributesPolyvalent != undefined && products[i].attributesPolyvalent.length > 0 && !validationError){
                    var productType = $('[name="productType"]').val();
                    if(productType == 'clip') {
                        if($('.attr-poly-table-js').index() != -1 && products[i].keys.length > 1){
                            products[i].keys.pop();
                            for(var k=0; k<products[i].keys.length; k++){
                                if(!parameter.attributeId){
                                    parameter.attributeId = [];
                                }
                                parameter.attributeId.push(products[i].keys[k].toString());
                            }
                        }
                    }
                    else {
                        var attributeInputs = $('[name="attributeId"]');
                        for(var l=0; l<attributeInputs.length; l++)
                        {
                            if(!parameter.attributeId){
                                parameter.attributeId = [];
                            }
                            parameter.attributeId.push(attributeInputs[l].value);
                        }
                    }
                    
                    for(var j=0; j<products[i].attributesPolyvalent.length; j++){
                        if(products[i].attributesPolyvalent[j] == ''){
                            validationError = true;
                            break;
                        }
                        if(!parameter.attributeId){
                            parameter.attributeId = [];
                        }
                        parameter.attributeId.push(products[i].attributesPolyvalent[j]);
                    }
                }
    
                if($(e.currentTarget).hasClass('add-to-inquiry-js') && window.app.getCookie('activeInquiryId') != undefined){
                    parameter.cartId = window.app.getCookie('activeInquiryId');
                }
    
                if (parameters) {
                    parameters.push(parameter);
                } else {
                    parameters = [parameter];
                }
    
                if($('.attr-poly-table-js').index() != -1){
                    quantity += Number(products[i].quantity);
                }
    
                if(parameters && !validationError && products[i].supply != undefined && typeof _edrone !== 'undefined'){
                    if(first){
                        _edrone.product_ids = products[i].supply;
                        _edrone.product_images = products[i].img;
                        _edrone.product_skus = products[i].code;
                        var name = _edrone.product_titles;
                        var url = _edrone.product_urls;
                        var categoryId = _edrone.product_category_ids;
                        var categoryName = _edrone.product_category_names;
                        first = false;
                    } else {
                        _edrone.product_ids += '|' + products[i].supply;
                        _edrone.product_images += '|' + products[i].img;
                        _edrone.product_skus += '|' + products[i].code;
                        _edrone.product_titles += '|' + name;
                        _edrone.product_urls += '|' + url;
                        _edrone.product_category_ids += '|' + categoryId;
                        _edrone.product_category_names += '|' + categoryName;
                    }
                }
            }
        }

        if(parameters == null){
            const isInquiry = e.currentTarget.classList.contains('add-to-inquiry-js');

            if (!isInquiry) {
                const inputs = document.querySelector('.add-to-cart-js[data-include]').querySelectorAll('[name="quantity"][type="text"]');
                const allUnits = document.querySelector('.add-to-cart-js[data-include]').querySelectorAll('.memory-js[data-index]');
                const addToCartButton =  document.querySelector('.add-many-products-js');

                app.MMQVal(inputs, allUnits, addToCartButton);
            }
            
            $('.at-least-one-product-info-js').removeClass('hidden-js');
            if ($('.at-least-one-product-info-js').length === 0) {
                app.temporaryPopupMessage(undefined, __translations.fillQuantityOfChoosenProducts, 'warn');
            }
        } else {
            $('.at-least-one-product-info-js').addClass('hidden-js');
        }
    
        if($('.attr-poly-table-js').index() != -1 && quantity > max){
            validationError = true;
            app.temporaryPopupMessage(undefined, __translations.stockLvlExceeded, 'err');
        }

        const clonedEvent = {...e};
        if(parameters && !validationError){
            var obj = {
                parameters: JSON.stringify(parameters),
                loadParent: loadParent,
                e: clonedEvent,
                form: form
            };
            var activeInquiryId = window.app.getCookie('activeInquiryId');
            if((activeInquiryId == -1 || activeInquiryId == '') && $(e.currentTarget).hasClass('add-to-inquiry-js')){
                $.post('', {__action: 'Cart/Create', inquiry: true, __csrf: __CSRF}, function(result) {
                    var inquiryId = result.action.Object.CartId;
                    for(var i=0; i<parameters.length; i++){
                        parameters[i].cartId = inquiryId;
                    }
                    obj.parameters = JSON.stringify(parameters);
                    js.addManyProductsToCart(obj, clonedEvent);
                });
            } else {
                js.addManyProductsToCart(obj, clonedEvent);
            }
        }
    },
    chooseCart: (e) => {
        var parent = $(e.currentTarget).parents('.add-to-cart-form-container-js');
        if($(e.currentTarget).is('[data-current-cart-id]')){
            var id = $(e.currentTarget).data('current-cart-id');
            $.post('', {__csrf: __CSRF, __action: 'Cart/Change', id: id}, function(){
                if($('.child-js').index() != -1 && !$(e.currentTarget).hasClass('escape-editing-js')){
                    js.addManyProducts(e);
                } else {
                    app.post(e);
                    app.reload();
                }
            });
        } else {
            var id = $(e.currentTarget).data('id');
            var name = $(e.currentTarget).data('name');
            parent.find('[name="id"]').val(id);
            app.post(e);
            parent.find('.cart-name-js').text(name);
            parent.find('.choose-cart-form-js').addClass('hidden-js');
            parent.find('.add-to-cart-button-js').removeClass('hidden-js');
            parent.find('.change-cart-label-js').addClass('hidden-js');
        }
    },
    getChildren: (n, skipMe) => {
        var r = [];
        for ( ; n; n = n.nextSibling ) 
           if ( n.nodeType == 1 && n != skipMe)
              r.push( n );        
        return r;
    },
    getSiblings: (n) => {
        return js.getChildren(n.parentNode.firstChild, n);
    },
	events: () => {
		$('body').on('click', '.stop-propagation-js', function (e) {
			e.stopPropagation();
		});
		js.delegate(document, 'click', '.deligoo-fail-js', () => {
            $('.change-delivery-js:not(.payment-js)').each(function() {
                if ($(this).val() == window.oldSelectVal) {
                    $(this).trigger('click');
                }
            });
		});

		js.delegate(document, 'click', '.close-deligoo-popup-js:not(.deligoo-fail-js)', async () => {
			const template = await js.get('template', 'elements/cart/' + __cartId + '.html');
			document.getElementsByClassName('order-template-js')[0].outerHTML = template;
            app.formLabelAnimationOnLoadPage();
		});

		if(document.getElementsByClassName('check-deligoo-when-enter-cart-js').length > 0){
			document.getElementsByClassName('check-deligoo-when-enter-cart-js')[0].click();
		}

		js.delegate(document.body, 'click', '.produce-offer-js', js.produceOffer);

		js.delegate(document.body, 'click', '.remove-js', e => {
			const parent = js.parents(e.target, 'container-to-remove-js');
			if(parent){
				parent.remove();
			} else {
				e.target.remove();
			}
            document.body.classList.remove('modal-opened');
		});

        js.delegate(document.body, 'click', '.show-more-manufacturers-js', js.showMoreManufacturers);
        js.delegate(document.body, 'click', '.show-less-manufacturers-js', js.showLessManufacturers);   

        js.delegate(document.body, 'click', '.wishlist-container-js .change-quantity-js', js.setTotalPriceOnProductsList);
        js.delegate(document.body, 'change', '.wishlist-container-js [name=quantity]', js.setTotalPriceOnProductsList);

        js.delegate(document.body, 'click', '.wishlist-container-js .change-quantity-js', js.setDepositPriceOnProductsList);
        js.delegate(document.body, 'change', '.wishlist-container-js [name=quantity]', js.setDepositPriceOnProductsList);

        $('body').on('click', '.choose-rating-js', (e) => {
            js.chooseRating(e);
        });

        js.delegate(document.body, 'click', '.open-add-review-form-js', js.openAddReviewForm);

        js.delegate(document.body, 'click', '.toggle-more-review-js', js.toggleMoreReview);

        js.delegate(document.body, 'click', '.download-more-reviews-js', js.downloadMoreReviews);

        $('body').on('click', '.add-review-js', function (e) {
            js.addReview(e);
        });

        $('body').on('click', '.toggle-employee-js', function (e) {
            js.toggleEmployee(e);
        });
        if(document.getElementsByClassName('form-error-js').length > 0) {
            js.delegate(document, 'click', '.recalculate-cart-js', () => {
                window.app.recalculateCart('partials/common/header/client-area.html');
            });
        }
        
        $('body').on('click', '.load-erp-order-details-js', function(e) {
            window.erpOrderId = undefined;
            window.erpPageNo = 1;
            if ($(e.currentTarget).attr('data-id')) {
                window.erpOrderId = $(e.currentTarget).data('id');
            } else if ($(e.currentTarget).find('.id-js').index != -1) {
                window.erpOrderId = Number($(e.currentTarget).find('.id-js').text());
            } else {
                window.erpOrderId = $(e.currentTarget).find('[data-id]').data('id');
            }
        
            if (window.erpPageNo === undefined) {
                window.erpPageNo = 1;
            }
            if (window.pagerEventsInitializedOrder === undefined) {
                js.pagerEvents('order');
            }
        
            app.replaceTemplate(e, undefined, js.loadErpDetails, 'order');
        });
        
        $('body').on('click', '.load-erp-invoice-details-js', function(e) {
            window.erpInvoiceId = undefined;
            window.erpPageNo = 1;
            if ($(e.currentTarget).attr('data-id')) {
                window.erpInvoiceId = $(e.currentTarget).data('id');
            } else {
                window.erpInvoiceId = $(e.currentTarget).find('[data-id]').data('id');
            }
        
            if (window.erpPageNo === undefined) {
                window.erpPageNo = 1;
            }
            if (window.pagerEventsInitializedInvoice === undefined) {
                js.pagerEvents('invoice');
            }
        
            app.replaceTemplate(e, undefined, js.loadErpDetails, 'invoice');
        });
        
        $('body').on('click', '.load-erp-sor-details-js', function(e) {
            window.erpSORId = undefined;
            window.erpPageNo = 1;
            if ($(e.currentTarget).attr('data-id')) {
                window.erpSORId = $(e.currentTarget).data('id');
            } else {
                window.erpSORId = $(e.currentTarget).find('[data-id]').data('id');
            }
        
            if (window.erpPageNo === undefined) {
                window.erpPageNo = 1;
            }
            if (window.pagerEventsInitializedSOR === undefined) {
                js.pagerEvents('sor');
            }
        
            app.replaceTemplate(e, undefined, js.loadErpDetails, 'sor');
        });
        
        $('body').on('click', '.load-erp-wm-details-js', function(e) {
            window.erpWMId = undefined;
            window.erpPageNo = 1;
            if ($(e.currentTarget).attr('data-id')) {
                window.erpWMId = $(e.currentTarget).data('id');
            } else {
                window.erpWMId = $(e.currentTarget).find('[data-id]').data('id');
            }
        
            if (window.erpPageNo === undefined) {
                window.erpPageNo = 1;
            }
            if (window.pagerEventsInitializedWM === undefined) {
                js.pagerEvents('wm');
            }
        
            app.replaceTemplate(e, undefined, js.loadErpDetails, 'wm');
        });

        $('body').on('click', '.choose-cart-js', function (e) {
            e.preventDefault();
            js.chooseCart(e);
        });
        
        if(document.getElementsByClassName('child-js').length > 0 || document.getElementsByClassName('choose-variant-js').length > 0 || document.getElementsByClassName('lookbook-js').length > 0){
            $('body').on('click', '.add-many-products-js', function(e) {
                e.preventDefault();
                js.addManyProducts(e);
            });
        }

        js.delegate(document.body, 'click', '.change-view-js', js.showSuggestedPrice);
 
        if(document.getElementsByClassName('suggested-price-product-list').length > 0){
            $(window).on('load', function() {
                js.showSuggestedPrice();
            });
        }

        if (document.getElementsByClassName('review-content-js').length > 0) {
            const elements = document.getElementsByClassName('review-content-js');
            for(let element of elements){
                if (element.offsetHeight == element.scrollHeight) {
                    const buttons = element.parentNode.getElementsByClassName('toggle-more-review-js');
                    for(let button of buttons){
                        button.classList.add('hidden-js');
                    }
                }
            }
        }

        if(window.innerWidth <= 1279) {
            const manufacturers = document.getElementsByClassName('manufacturer-js')
            for(let manufacturer of manufacturers){
                manufacturer.classList.remove('hidden-js');
            }
        }

        setTimeout(() => {
            if(location.hash.includes('#rate')){
                $('[data-scroll-to-paragraph=".reviews-js"]').trigger('click');
            };
            if(__isB2B != 'true' && document.getElementsByClassName('wishlist-container-js').length > 0){
                js.updateTotalPriceOnShoppingList();
                js.updateDepositPriceOnShoppingList();
            }
        }, 1000);
	}
};

(function () {
    'use strict';

    if (!body) {
        var body = $('body');
    }

    if ($('.customer-profile-content-js').length > 0 || $('.editing-order-merge-js').length > 0) {
        //EDITING ORDER implementation
        function EditOrder(id, orderTemplateContainerSelector, orderTemplateUrl, messagesContainerSelector, recalculationInitStateSelector, callbackEveryOrderOpening, callbackFirstOrderOpening) {
            this.orderTemplateContainer = $(orderTemplateContainerSelector);
            this.orderTemplateUrl = orderTemplateUrl;
            this.recalculationRequired = false;
            this.recalculationInitStateSelector = recalculationInitStateSelector;
            this.orderId = id || null;
            this.orderRequestUrl = null;

            // listen for order opening, gets id of the order and execute given functions after details were opened
            this.listenForOrderOpening = function (callbackEveryOpen, callbackFirstOpen) {
                var thisRef = this;
                body.on('openProfileOrder', function (e, data) {
                    thisRef.orderId = data.id;
                    thisRef.orderRequestUrl = data.orderRequestUrl;
                    if (callbackEveryOpen) {
                        callbackEveryOpen(data.id);
                    }
                });

                if (callbackFirstOpen) {
                    body.on('openProfileOrder', function (e, data) {
                        callbackFirstOpen(data.id);
                    });
                }
            }
            this.listenForOrderOpening(callbackEveryOrderOpening, callbackFirstOrderOpening);

            // makes request for start editing process, returns request's promise
            this.edit = function (aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/Edit',
                    __csrf: __CSRF,
                    orderId: this.orderId,
                    __template: this.orderTemplateUrl,
                    __collection: 'customer-profile.Order.RecalculationRequired'
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    window.UIFeatures.pureReplaceTemplate(thisRef.orderTemplateContainer, null, null, res.template, thisRef.orderRequestUrl);
                    if (!res.action.Result) {
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action, 'warning'));
                    }
                    thisRef.recalculationRequired = res.collection;
                });
            }

            // makes request for creating cart for order edition, returns request's promise
            this.cartCreate = function (aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/CartCreate',
                    __csrf: __CSRF,
                    orderId: this.orderId,
                    __template: this.orderTemplateUrl,
                    __collection: 'config.DefinedPages.Home.Url|customer-profile.OrderQueryGET'
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    // check if cartId avalible, and put in cookies
                    if (!res.action.Result) {
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action, 'warning'));
                    } else {
                        window.app.setCookie('OrderQueryGET', res.collection['customer-profile.OrderQueryGET']);
                        var homeUrl = res.collection['config.DefinedPages.Home.Url'] || '';
                        window.app.newUrl((homeUrl.indexOf('//') === 0 || homeUrl.indexOf('://') > -1) ? homeUrl : ($('base').attr('href') || '') + homeUrl.replace(/^\.\//, ''));
                    }
                });
            }

            //makes request for deleting position, returns request's promise
            this.positionDelete = function (posNo, aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/PositionDelete',
                    __csrf: __CSRF,
                    no: posNo,
                    orderId: this.orderId,
                    __template: this.orderTemplateUrl,
                    __collection: 'customer-profile.Order.RecalculationRequired'
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    window.UIFeatures.pureReplaceTemplate(thisRef.orderTemplateContainer, null, null, res.template, thisRef.orderRequestUrl);
                    if (!res.action.Result) {
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action, 'warning'));
                    }
                    thisRef.recalculationRequired = res.collection;
                });
            }

            // makes request for changing quantity of position, returns request's promise
            this.positionQuantityChange = function (posNo, quantity, messagesContainerSelector, aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/PositionQuantityChange',
                    __csrf: __CSRF,
                    no: posNo,
                    orderId: this.orderId,
                    quantity: quantity,
                    __template: this.orderTemplateUrl,
                    __collection: 'customer-profile.Order.RecalculationRequired'
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                if(aditionalRequestData.orderDetPageId && thisRef.orderRequestUrl.indexOf('orderDetPageId='+aditionalRequestData.orderDetPageId) === -1){
                    if(thisRef.orderRequestUrl.indexOf('orderDetPageId') !== -1){
                        thisRef.orderRequestUrl = thisRef.orderRequestUrl.substring(0, thisRef.orderRequestUrl.indexOf('&orderDetPageId')) + '&orderDetPageId=' + aditionalRequestData.orderDetPageId;
                    } else {
                        thisRef.orderRequestUrl = thisRef.orderRequestUrl + '&orderDetPageId=' + aditionalRequestData.orderDetPageId;
                    }
                }

                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    window.UIFeatures.pureReplaceTemplate(thisRef.orderTemplateContainer, null, null, res.template, thisRef.orderRequestUrl);
                    if (!res.action.Result) {
                        var container = $(messagesContainerSelector);
                        container.find('.error-msg-js').remove();
                        var messageContainer = '<div class="quantity-error error-msg-js">'+res.action.Description+'</div>';
                        container.append(messageContainer);
                        container.find('.error-msg-js').delay(3000).fadeOut(300, function(){
                            $(this).remove();
                        });
                    }
                    thisRef.recalculationRequired = res.collection;
                });
            }

            // makes request for merging cart with edited order, returns request's promise
            this.cartMerge = function (messagesContainerSelector, aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/CartMerge',
                    __csrf: __CSRF,
                    __collection: 'config.DefinedPages.CustomerProfile.Url'
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                return window.UIFeatures.makePostRequest(data, null, function (res) {
                    if (res.action.Result) {
                        //temp order url - to change in future (when profile routing will be implemented)
                        var orderQueryGET = window.app.getCookie('OrderQueryGET');
                        window.app.setCookie('OrderQueryGET', '', -1);
                        window.app.setCookie('lastCartId', -1);
                        var profileUrl = res.collection || '';
                        profileUrl = (profileUrl.indexOf('//') === 0 || profileUrl.indexOf('://') > -1) ? profileUrl : ($('base').attr('href') || '') + profileUrl;
                        if(orderQueryGET.indexOf('&tab=order-details') === -1){
                            window.app.newUrl(profileUrl + '?' + orderQueryGET + '=' + thisRef.orderId + '&tab=order-details');
                        } else {
                            window.app.newUrl(profileUrl + '?' + orderQueryGET + '=' + thisRef.orderId);
                        }
                    } else {
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action));
                    }
                });
            }

            // makes request for undo position changes, returns request's promise
            this.positionUndo = function (posNo, aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/PositionUndo',
                    __csrf: __CSRF,
                    no: posNo,
                    orderId: this.orderId,
                    __template: this.orderTemplateUrl,
                    __collection: 'customer-profile.Order.RecalculationRequired'
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    window.UIFeatures.pureReplaceTemplate(thisRef.orderTemplateContainer, null, null, res.template, thisRef.orderRequestUrl);
                    if (!res.action.Result) {
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action, 'warning'));
                    }
                    thisRef.recalculationRequired = res.collection;
                });
            }

            // makes request for undo all order's changes, returns request's promise
            this.undo = function (aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/Undo',
                    __csrf: __CSRF,
                    orderId: this.orderId,
                    __template: this.orderTemplateUrl,
                    __collection: 'customer-profile.Order.RecalculationRequired'
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;

                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    window.UIFeatures.pureReplaceTemplate(thisRef.orderTemplateContainer, null, null, res.template, thisRef.orderRequestUrl);
                    if (!res.action.Result) {
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action, 'warning'));
                    }
                    thisRef.recalculationRequired = res.collection;
                });
            }

            // makes request for apply all changes, returns request's promise
            this.accept = function (aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/Accept',
                    __csrf: __CSRF,
                    orderId: this.orderId,
                    __template: this.orderTemplateUrl,
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    window.UIFeatures.pureReplaceTemplate(thisRef.orderTemplateContainer, null, null, res.template, thisRef.orderRequestUrl);
                    if (!res.action.Result) {
                        $('.during-ajax-modal-js').addClass('hidden-js');
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action, 'warning'));
                    }
                    thisRef.recalculationRequired = false;
                    window.app.setCookie('lastCartId', -1);
                });
            }

            this.showConfirmCancelPopup = function(popupSelector, hiddingClass) {
                var popup = $(popupSelector);
                popup.addClass('edit-order-cancel-js');
                $(popupSelector).removeClass(hiddingClass);
            }

            // makes request for cancel all changes, returns request's promise
            this.cancel = function (aditionalRequestData) {
                var data = {
                    __action: 'OrderEdit/Cancel',
                    __csrf: __CSRF,
                    orderId: this.orderId,
                    __template: this.orderTemplateUrl,
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    window.UIFeatures.pureReplaceTemplate(thisRef.orderTemplateContainer, null, null, res.template, thisRef.orderRequestUrl);
                    if (!res.action.Result) {
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action, 'warning'));
                    }
                    thisRef.recalculationRequired = false;
                    window.app.setCookie('lastCartId', -1);
                    if($('.escape-editing-js').length > 0 ){
                        $('.escape-editing-js').trigger('click');
                    }
                });
            }

            this.recalculate = function(aditionalRequestData) {
                $('.during-ajax-modal-js').removeClass('hidden-js');
                var data = {
                    __action: 'OrderEdit/Recalculate',
                    __csrf: __CSRF,
                    orderId: this.orderId,
                    __template: this.orderTemplateUrl,
                };

                if (aditionalRequestData) {
                    data = $.extend(data, aditionalRequestData);
                }

                var thisRef = this;
                return window.UIFeatures.makePostRequest(data, thisRef.orderRequestUrl, function (res) {
                    window.UIFeatures.pureReplaceTemplate(thisRef.orderTemplateContainer, null, null, res.template, thisRef.orderRequestUrl);
                    if (!res.action.Result) {
                        var messagesContainer = $(messagesContainerSelector);
                        window.app.temporaryMessage(messagesContainer, window.UIFeatures.makeMessageHtml(res.action, 'warning'));
                    }
                    thisRef.recalculationRequired = false;
                    $('.during-ajax-modal-js').addClass('hidden-js');
                });

            }

            // TEMP: opens given order in profile.
            this.openOrder = function (id) {
                app.replaceTemplate(e, undefined, function (e) {
                    if ($(e.currentTarget).hasClass('open-order-details-js')) {
                        $('body').trigger('openProfileOrder',
                            {
                                id: $(e.currentTarget).data('id') || null,
                                orderRequestUrl: $(e.currentTarget).data('url')
                            }
                        );
                    }
                }, e);

            }
        }

        //EDITING ORDER binding
        //init
        window.editOrder = new EditOrder(
            $('.editing-order-id-js').text() || null,
            '.parent-container-js',
            'partials/customer-profile/orders/order-details.html',
            '.messages-container-js',
            '.recalculation-required',
            null,
            function (id) {
                body.off('click', '.order-edit-js');
                body.off('click', '.order-editing-quantity-js');
                body.off('click', '.order-editing-quantity-change-js');
                body.off('click', '.undo-order-edition-js');
                body.off('click', '.cancel-order-edition-js');
                body.off('click', '.confirmation-popup-js.edit-order-cancel-js .yes-js');
                body.off('click', '.undo-order-position-js');
                body.off('click', '.remove-editing-order-position-js');
                body.off('click', '.recalculate-editing-order-js');
                body.off('click', '.accept-order-edition-js');
                body.off('click', '.order-edition-cart-create-js');

                //initialize stuff that should be initialized after order opening at the first time (once)
                //edit order
                body.on('click', '.order-edit-js', function (e) {
                    e.preventDefault();
                    window.editOrder.edit();
                });

                //change items quantity
                body.on('change', '.order-editing-quantity-js', function (e) {
                    e.preventDefault();
                    var input = $(this);
                    var no = input.parents('[data-product-no]').data('product-no');
                    var validationCases = input.parents('.form-js').find('.validation-info-js');
                    var validationError = false;
                    app.validation(e);
                    validationCases.each(function () {
                        if(!$(this).hasClass('hidden-js')){
                            validationError = true;
                        }
                    });
                    if(validationError == false){
                        var page = $('[data-current]').data('current');
                        window.editOrder.positionQuantityChange(no, input.val(), '[data-product-no="'+ no +'"] .change-quantity-in-cart-js', {orderDetPageId: page});
                    }
                });

                body.on('click', '.order-editing-quantity-change-js', function (e) {
                    e.preventDefault();
                    var button = $(this);
                    var no = button.parents('[data-product-no]').data('product-no');
                    window.app.changeQuantity(e, function () {
                        var validationCases = button.parents('.form-js').find('.validation-info-js');
                        var validationError = false;
                        app.validation(e, button.siblings('[name="quantity"]'));
                        validationCases.each(function () {
                            if(!$(this).hasClass('hidden-js')){
                                validationError = true;
                            }
                        });
                        if(validationError == false){
                            var quantity = button.siblings('[name="quantity"]').val();
                            var page = $('[data-current]').data('current');
                            window.editOrder.positionQuantityChange(no, quantity, '[data-product-no="' + no + '"] .change-quantity-in-cart-js', {orderDetPageId: page});
                        }
                    });
                });

                body.on('click', '.undo-order-edition-js', function (e) {
                    e.preventDefault();
                    window.editOrder.undo();
                });

                body.on('click', '.cancel-order-edition-js', function (e) {
                    e.preventDefault();
                    window.editOrder.showConfirmCancelPopup('.confirmation-popup-js', 'hidden-js');
                });

                body.on('click', '.confirmation-popup-js.edit-order-cancel-js .yes-js', function (e) {
                    e.preventDefault();
                    window.editOrder.cancel();
                });

                body.on('click', '.undo-order-position-js', function (e) {
                    e.preventDefault();
                    var no = $(this).parents('[data-product-no]').data('product-no');
                    window.editOrder.positionUndo(no);
                });

                body.on('click', '.remove-editing-order-position-js', function (e) {
                    e.preventDefault();
                    var no = $(this).parents('[data-product-no]').data('product-no');
                    window.editOrder.positionDelete(no);
                });

                body.on('click', '.recalculate-editing-order-js', function (e) {
                    e.preventDefault();
                    window.editOrder.recalculate();
                });

                // var headerAttributesEdit = function(positionAttributesValid){
                //     var isValid = true;
                //     var inputs = $('.header-attributes-set-form-js [name="attribute"]');

                //     inputs.each(function(){
                //         if($(this).prop('required') && $(this).val() == ''){
                //             isValid = false;
                //             $(this).parent().find('.validation-required-js').removeClass('hidden-js');
                //         }
                //     });
                //     if(isValid && (positionAttributesValid || positionAttributesValid == undefined)){
                //         $('.products-table-js .form-error-js').remove();
                //         $('.header-attributes-set-form-js .form-error-js').remove();
                //         var data = $('.header-attributes-set-form-js').find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
                //         data.push({ name: '__csrf', value: __CSRF });
                //         $.post(null, data).then(function () {
                //             window.editOrder.accept();
                //         });
                //     } else {
                //         if(!isValid){
                //             if($('.header-attributes-set-form-js .form-error-js').index() == -1){
                //                 $('.header-attributes-set-form-js').prepend('<div class="form-error-js message-bar-ui warning-bar-ui">' + __translations.fillRequiredAttributes + '</div>');
                //             }
                //         } else {
                //             $('.header-attributes-set-form-js .form-error-js').remove();
                //         }
                //         if(!positionAttributesValid){
                //             if($('.products-table-js .form-error-js').index() == -1){
                //                 $('.show-attributes-js').trigger('click');
                //                 $('.products-table-js').prepend('<div class="form-error-js message-bar-ui warning-bar-ui">' + __translations.fillRequiredAttributes + '</div>');
                //             }
                //         } else {
                //             $('.products-table-js .form-error-js').remove();
                //         }
                //     }
                // }

                body.on('click', '.accept-order-edition-js', function (e) {
                    e.preventDefault();
                    var forms = $('.products-table-js').find('.position-attributes-set-form-js');
                    if(forms.length > 0){
                        var promisesArray = null;
                        var globalPromise = null;
                        var allFormsValid = true;
                        forms.each(function(){
                            var form = $(this);
                            var isValid = true;
                            var inputs = form.find('[name="attribute"]');

                            inputs.each(function(){
                                if($(this).prop('required') && $(this).val() == ''){
                                    allFormsValid = false;
                                    isValid = false;
                                    $(this).parent().find('.validation-required-js').removeClass('hidden-js');
                                }
                            });

                            if(isValid){
                                var data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
                                data.push({ name: '__csrf', value: __CSRF });
                                var thisPromise = $.post('', data);
                                if (promisesArray) {
                                    promisesArray.push(thisPromise);
                                } else {
                                    promisesArray = [thisPromise];
                                }
                            }
                        });

                        if (promisesArray) {
                            globalPromise = $.when.apply($, promisesArray);
                            globalPromise.then(function () {

                                if($('.header-attributes-set-form-js').index() != -1){
                                    headerAttributesEdit(allFormsValid);
                                } else {
                                    if(allFormsValid){
                                        $('.products-table-js .form-error-js').remove();
                                        window.editOrder.accept();
                                    } else {
                                        $('.show-attributes-js').trigger('click');
                                        // if($('.products-table-js').find('.form-error-js').index() == -1){
                                        //     $('.products-table-js').prepend('<div class="form-error-js message-bar-ui warning-bar-ui">' + __translations.fillRequiredAttributes + '</div>');
                                        // }
                                    }
                                }
                            });
                        } else {
                            $('.during-ajax-modal-js').addClass('hidden-js');
                            $('.show-attributes-js').trigger('click');
                            // if($('.products-table-js').find('.form-error-js').index() == -1){
                            //     $('.products-table-js').prepend('<div class="form-error-js message-bar-ui warning-bar-ui">' + __translations.fillRequiredAttributes + '</div>');
                            // }
                        }
                    } else if($('.header-attributes-set-form-js').index() != -1){
                        headerAttributesEdit();
                    } else {
                        window.editOrder.accept();
                    }
                })

                body.on('click', '.order-edition-cart-create-js', function (e) {
                    e.preventDefault();
                    window.editOrder.cartCreate();
                });
            }
        );

        var customerProfileContainer = $('.customer-profile-content-js');
        if (customerProfileContainer.data('order-id')) {
            $('body').trigger('openProfileOrder',
                {
                    id: customerProfileContainer.data('order-id') || null,
                    orderRequestUrl: customerProfileContainer.data('order-url') || null
                }
            );
        }

        body.on('click', '.editing-order-merge-js', function (e) {
            e.preventDefault();
            if($('.attributes-view-js').index() != -1){
                if($('[name="attribute"]').index() != -1){
                    var isValid = true;
                    var attributes = $('[name="attribute"]');
                    attributes.each(function(){
                        if($(this).prop('required') && $(this).val() == ''){
                            isValid = false;
                            $(this).parents('.attributes-view-js').find('.validation-required-js').removeClass('hidden-js');
                        }
                    });
                }

                if(isValid){
                    $('.order-template-js .during-ajax-modal-js').removeClass('hidden-js');
                    var promisesArray = null;
                    var globalPromise = null;
                    var products = $('.position-attributes-set-form-js');
                    products.each(function(){
                        var form = $(this);
                        var data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
                        data.push({ name: '__csrf', value: __CSRF });
                        var thisPromise = $.post('', data);
                        if (promisesArray) {
                            promisesArray.push(thisPromise);
                        } else {
                            promisesArray = [thisPromise];
                        }
                    });
                    if (promisesArray) {
                        globalPromise = $.when.apply($, promisesArray);
                        globalPromise.then(function () {
                            window.editOrder.cartMerge('.products-table-js');
                        });
                    } else {
                        $('.order-template-js .during-ajax-modal-js').addClass('hidden-js');
                    }
                } else {
                    $('.show-attributes-js').trigger('click');
                }
            } else {
                $('.order-template-js .during-ajax-modal-js').removeClass('hidden-js');
                window.editOrder.cartMerge('.products-table-js');
            }
        });

        body.on('click', '.go-to-order-js', function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.editOrder.openOrder($(this).data('id'));
        });
    }

    body.on('click', '.escape-editing-js', function (e) {
        e.preventDefault();
        js.chooseCart(e);
        window.app.setCookie('lastCartId', -1);
    });

    body.on("click", ".select-discount-js", function(e) {
        if(typeof gtag != 'undefined'){
            gtag("event", "select_promotion", {
                promotion_name: $(e.currentTarget).data('name')
            });
        }
    });

    body.on('keypress', '[name="$minPrice"], [name="$maxPrice"], [name="priceFrom"], [name="priceTo"]', function(e) {
        const key = e.which || e.keyCode;
        if (key === 188 || key === 44){
            e.preventDefault();
        }
    });

    body.on("click", ".form__input-value--clear-button", function() {
        $(this).closest('.form__input-wrapper').find('input[name="attributeEditable"]').val('');
        $(this).closest('.form__input-wrapper').find('input[name="attributeEditable"]').removeClass('has-value');
        app.formLabelAnimationOnLoadPage();
    });

    body.on("keyup", "input[type='text'].input-value-js", function () {
        if ($(this).val().trim() !== "") {
            $(this).addClass("has-value");
        } else {
            $(this).removeClass("has-value");
        }
    });
    // Event listeners for coupon popup
    body.on('click', '.show-more-coupons-product-list-js', function (e) {
        e.preventDefault();
        const productId = $(this).data('product-id');
        const productUrl = $(this).data('url');
        
        window.CouponPopupManager.showCouponPopup({
            productId: productId,
            productUrl: productUrl,
            triggerElement: this
        });
    });

    body.on('click', '.show-more-coupons-cart-js', function (e) {
        e.preventDefault();
        const productId = $(this).data('product-id');
        
        window.CouponPopupManager.showCouponPopup({
            productId: productId,
            isCart: true,
            triggerElement: this
        });
    });

    body.on('click', '.show-more-coupons-product-details-js', function (e) {
        e.preventDefault();
        const productId = $(this).data('id') || $(this).data('product-id');
        
        window.CouponPopupManager.showCouponPopup({
            productId: productId,
            isProductDetails: true,
            triggerElement: this
        });
    });

    body.on('click', '.show-more-coupons-with-attributes-product-list-js', function(e) {
        e.preventDefault();
        const productId = $(this).data('product-id');
        const productUrl = $(this).data('url');
        
        window.CouponPopupManager.showCouponPopup({
            productId: productId,
            productUrl: productUrl,
            triggerElement: this
        });
    });
    
    body.on('click', '.coupons-on-product-presentation-js', function(e) {
        e.preventDefault();
        
        var $this = $(this);
        if ($this.data('clicking')) {
            return;
        }
        
        $this.data('clicking', true);
        
        const productId = $this.data('id');
        
        if (productId) {
            window.CouponPopupManager.showCouponPopup({
                productId: productId,
                isProductDetails: true,
                triggerElement: this
            });
        }
        
        setTimeout(function() {
            $this.removeData('clicking');
        }, 0);
    });
})();

    Number.prototype.format = function(n, x, s, c) {
        let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = this.toFixed(Math.max(0, ~~n));
    
        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };

    Number.prototype.toPrice = function (d) {
        const decimalPlaces = d || __decimalPlacesPrice || 2;
        return this.format(decimalPlaces, 3, ' ', __decSep);
    };

`